export const TICKET_CLOSURE_REQUIRED_FIELDS = [
  { fieldKey: 'cf_channelapplication', label: 'Country', source: 'custom' },
  { fieldKey: 'status', label: 'Status', source: 'status' },
  { fieldKey: 'cf_product', label: 'Product', source: 'custom' },
  { fieldKey: 'priority', label: 'Priority', source: 'priority' },
  { fieldKey: 'ticket_type', label: 'Type', source: 'ticketType' },
  { fieldKey: 'group', label: 'Group', source: 'group' },
  { fieldKey: 'cf_level', label: 'Level', source: 'custom' },
  { fieldKey: 'cf_issue_fixed_by_agent', label: 'Issue Fixed By Agent', source: 'custom' },
  { fieldKey: 'cf_rca', label: 'RCA', source: 'custom' },
  { fieldKey: 'cf_rca_category858253', label: 'RCA Category', source: 'custom' },
  { fieldKey: 'cf_root_cause_resolved', label: 'Root Cause Resolved', source: 'custom' },
  { fieldKey: 'cf_summary_of_resolution', label: 'Summary of Resolution', source: 'custom' },
] as const;

type TicketClosureFieldSource = (typeof TICKET_CLOSURE_REQUIRED_FIELDS)[number]['source'];

export interface TicketClosureValues {
  status?: unknown;
  priority?: unknown;
  ticketType?: unknown;
  group?: unknown;
  customFields?: Readonly<Record<string, unknown>> | null;
}

function hasValue(value: unknown): boolean {
  return value !== undefined
    && value !== null
    && !(typeof value === 'string' && value.trim() === '')
    && !(Array.isArray(value) && value.length === 0);
}

function valueForSource(source: TicketClosureFieldSource, fieldKey: string, values: TicketClosureValues): unknown {
  if (source === 'status') return values.status;
  if (source === 'priority') return values.priority;
  if (source === 'ticketType') return values.ticketType;
  if (source === 'group') return values.group;
  if (!values.customFields || typeof values.customFields !== 'object' || Array.isArray(values.customFields)) return undefined;
  return values.customFields[fieldKey];
}

export function validateTicketClosureFields(values: TicketClosureValues): Record<string, string> {
  return Object.fromEntries(
    TICKET_CLOSURE_REQUIRED_FIELDS
      .filter((field) => !hasValue(valueForSource(field.source, field.fieldKey, values)))
      .map((field) => [field.fieldKey, `${field.label} is required`]),
  );
}
